(function () {

  function fixZoomImages() {
    document.querySelectorAll('img.zoomImg').forEach(img => {
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
    });
  }

  fixZoomImages();

  const observer = new MutationObserver(fixZoomImages);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();